<template lang="pug">
global-form-group(
    :field-name="field.name"
    :title="field.title"
    :show-label="showLabel"
)
    div.desktop-select-date
        div
            select(v-model.number="date.day")
                option(v-for="d in days" :key="d" :value="d") {{ d }}
        div
            select(v-model.number="date.month")
                option(v-for="m in months" :key="m" :value="m") {{ m }}
        div
            select(v-model.number="date.year")
                option(v-for="y in years" :key="y" :value="y") {{ y }}

    div.desc(v-if="field.description") {{ field.description }}
</template>

<script>
import GlobalFormGroup from "../../GlobalFormGroup";

export default {
    name: "DateDesktop",
    components: {GlobalFormGroup},
    props: {
        field: {},

        selected: {
            type: Object,
            default() {
                return {
                    value: {
                        day: 1,
                        month: 1,
                        year: 2021
                    }
                }
            }
        },
        showLabel: {
            type: Boolean,
            default: true
        },
    },

    data() {
        return {
            date: {
                day: 1,
                month: 1,
                year: 2021
            }
        }
    },

    mounted() {
        this.date = this.selected.value;
    },

    computed: {
        months() {
            return [
                1,2,3,4,5,6,7,8,9,10,11,12
            ]
        },

        dayOfMonth() {
            var min = 1;
            var max = 30;

            if ([1,3,5,7,8,10,12].indexOf(+this.date.month) >= 0) {
                max = 31;
            } else if (+this.date.month === 2) {
                max = 28;
                if (+this.date.year % 4 === 0) {
                    max = 29
                } else if (+this.date.year % 400 === 0) {
                    max = 29
                }
            }

            return {
                min,max
            }
        },

        days() {
            var out = [];
            for (var i = this.dayOfMonth.min; i <= this.dayOfMonth.max; i++) {
                out.push(i)
            }

            return out;
        },

        years() {
            var d = +(new Date()).getFullYear();
            var out = [];
            for (var i = d-80; i <= d+10; i++) {
                out.push(i)
            }
            return out;
        }
    },

    watch: {
        date: {
            handler(vl) {
                if (vl.day > this.dayOfMonth.max) {
                    vl.day = this.dayOfMonth.max;
                }
                var o = Object.assign({}, this.field, {
                    value: {
                        day : +vl.day,
                        month : +vl.month,
                        year : +vl.year,
                    }
                });
                this.$emit('select', o);
            },
            deep: true
        }
    },
}
</script>

<style lang="scss">
    .desktop-select-date {
        display: grid;
        grid-column-gap: 10px;
        grid-template-columns: 1fr 1fr 1fr;
        select {
            width: 100%;
            padding: 5px 10px;
            border: none;
            border-bottom: 1px solid #333;
            border-radius: 0;
            background-color: transparent;
        }
    }
</style>
